(function () {
  document.documentElement.classList.add('sleke-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = document.documentElement.classList.contains('shopify-design-mode');
  var revealEls = document.querySelectorAll('.sleke-reveal');

  if (reduced || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) {
      el.classList.add('sleke-revealed');
    });
  } else {
    /*
      Trigger on the element's leading edge, not on a percentage of it.

      This previously used { threshold: 0.12 }, which asks for 12% of the
      element to be visible at once. That is unreachable for anything taller
      than about 8x the viewport: a 12,900px guide needs 1,550px on screen at
      once, and a laptop viewport is ~720px. isIntersecting never became true,
      so the section stayed at opacity 0 forever — invisible, with its text
      present in the DOM the whole time.

      threshold 0 fires the moment any part of the element enters the box, and
      the negative bottom margin holds the reveal until the edge is 12% up from
      the bottom of the viewport. Same feel, independent of element height.
    */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sleke-revealed');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -12% 0px' }
    );

    revealEls.forEach(function (el) {
      io.observe(el);
    });

    /*
      Safety net: anything still unrevealed shortly after load gets shown.
      A reveal animation must never be the reason content cannot be read.
    */
    window.setTimeout(function () {
      document.querySelectorAll('.sleke-reveal:not(.sleke-revealed)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('sleke-revealed');
        }
      });
    }, 1200);
  }

  /* ---- Hero masthead decode ---- */
  var GLYPHS = '#@$%&*+=<>/\\';

  document.querySelectorAll('[data-sleke-decode]').forEach(function (el) {
    if (reduced || inEditor) return;

    var finalText = el.textContent;
    var frames = 18;
    var frame = 0;

    var timer = setInterval(function () {
      frame += 1;
      var revealCount = Math.floor((finalText.length * frame) / frames);
      var out = '';

      for (var i = 0; i < finalText.length; i += 1) {
        var ch = finalText.charAt(i);
        if (i < revealCount || ch === ' ' || ch === ',') {
          out += ch;
        } else {
          out += GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length));
        }
      }

      el.textContent = out;

      if (frame >= frames) {
        el.textContent = finalText;
        clearInterval(timer);
      }
    }, 34);
  });
})();
